import Component from '@glimmer/component';
import { action } from '@ember/object';
import { getArrayFromPromiseManyArray } from '../utils/promise-many-array';

export default class EventDashboardComponent extends Component
{
	get totalCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + classGroup.results.length;
		}, 0);
	}

	filterResultsSync(classGroup, filterFn)
	{
		// Access the results synchronously if loaded
		// Convert PromiseManyArray to plain array for filtering
		const results = getArrayFromPromiseManyArray(classGroup.results);
		return results.filter(filterFn).length;
	}

	get notFinishedCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "OK" && r.finishTime == undefined));
		}, 0);
	}

	get finishedCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status != "OK" || r.finishTime != undefined));
		}, 0);
	}

	get okCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "OK" && r.finishTime != undefined));
		}, 0);
	}

	get dnsCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "DNS"));
		}, 0);
	}

	get dnfCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "DNF"));
		}, 0);
	}

	get dsqCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "DSQ"));
		}, 0);
	}

	get susCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "SUS"));
		}, 0);
	}

	get ralCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "RAL"));
		}, 0);
	}

	get npsCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "NPS"));
		}, 0);
	}

	get mpCount()
	{
		const classGroups = getArrayFromPromiseManyArray(this.args.event.classGroups);
		return classGroups.reduce((sum, classGroup) => {
			return sum + this.filterResultsSync(classGroup, (r) => (r.status == "MP"));
		}, 0);
	}

	@action
	refresh()
	{
		if (this.args.onRefresh)
		{
			this.args.onRefresh();
		}
	};

	@action
	expandClassGroup(classGroup,category)
	{
		var isExpanded = classGroup.isExpandedDashboard;
		var expandedCategory = classGroup.dashboardExpansionCategory;

		if(isExpanded && category==expandedCategory)
		{
			classGroup.set('isExpandedDashboard',false);
		}
		else
		{
			classGroup.set('dashboardExpansionCategory',category);
			classGroup.set('isExpandedDashboard',true);
		}
	};
};